import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  KeyboardView,
  Row,
  Container,
  Card,
  Title
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import { updateDashboard } from "app/NativeActions";

import StepTab from "./StepTab";

import StartStep from "./StartStep";
import CreateNumberStep from "./CreateNumberStep";
import SavedRepliesStep from "./SavedRepliesStep";
import MultiSendStep from "./MultiSendStep";
import FinalStep from "./FinalStep";
import News from "app/DealMachineCore/components/Dashboard/News";
class MessageOnboardingSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_tab:
        props.user && props.user.current_message_step
          ? props.user.current_message_step
          : "message_start",
      tab_array: [
        {
          title: "Start",
          slug: "message_start",
          icon: "arrow-forward"
        },
        {
          title: "Create Number",
          slug: "create_number",
          icon: "phone"
        },
        {
          title: "Saved Replies",
          slug: "saved_replies",
          icon: "reply"
        },
        {
          title: "Send Messages",
          slug: "multi_send",
          icon: "chat"
        },
        {
          title: "Complete Training",
          slug: "message_final_step",
          fa_icon: "check"
        }
      ]
    };
    this._scroll_view = React.createRef();
    this.scrollToTop = this.scrollToTop.bind(this);
    this.updateTab = this.updateTab.bind(this);
  }

  scrollToTop() {
    if (this.props.device == "mobile") {
      if (this._scroll_view) {
        if (this._scroll_view.current) {
          this._scroll_view.current.scrollToPosition(
            0,
            this.props.platform == "android" ? -40 : 0
          );
        }
      }
    } else {
    }
  }

  updateTab(tab) {
    this.setState({
      active_tab: tab
    });

    this.scrollToTop();
  }

  renderTabs() {
    let selected_array = this.state.tab_array;
    let tab_array = [];
    if (this.props.dashboardMobile) {
      for (let i = 0; i < selected_array.length; i++) {
        if (selected_array[i].slug === this.state.active_tab) {
          if (i === 0) {
            tab_array = [
              selected_array[i],
              selected_array[i + 1],
              selected_array[i + 2]
            ];
          } else if (i === selected_array.length - 1) {
            tab_array = [
              selected_array[i - 2],
              selected_array[i - 1],
              selected_array[i]
            ];
          } else {
            tab_array = [
              selected_array[i - 1],
              selected_array[i],
              selected_array[i + 1]
            ];
          }
        }
      }
    } else {
      tab_array = selected_array;
    }

    return (
      <Row>
        {tab_array.map((tab, i) => {
          return (
            <StepTab
              key={i}
              title={tab.title}
              icon={tab.icon}
              fa_icon={tab.fa_icon}
              active={this.state.active_tab === tab.slug}
              onPress={() => this.updateTab(tab.slug)}
              colors={this.props.colors}
              dashboardMobile={this.props.dashboardMobile}
              show_tab={true}
            />
          );
        })}
      </Row>
    );
  }

  render() {
    return (
      <Container includeInfoBanner={true}>
        <Header
          title="Messages"
          leftButtonIcon="menu"
          leftButtonAction={
            this.props.device == "desktop"
              ? () => {
                  this.props.mobileToggleDrawer(
                    !this.props.mobile_toggle_drawer
                  );
                }
              : () => this.props.toggleDrawer("open")
          }
        />
        <KeyboardView style={{ maxWidth: 1200 }} scroll_ref={this._scroll_view}>
          <Wrapper
            style={{
              paddingTop: 0,
              paddingBottom: 20,
              padding: this.props.dashboardMobile ? 0 : 20
            }}
          >
            <Row
              style={{
                flexDirection: this.props.dashboardMobile ? "column" : "row"
              }}
            >
              <Wrapper style={{ alignSelf: "stretch", flex: 1 }}>
                <Card style={{ flex: 1 }}>
                  <Wrapper
                    style={{
                      backgroundColor: this.props.colors.background_color,
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5
                    }}
                  >
                    <Wrapper style={{ padding: 25 }}>
                      <Title>Message Engine</Title>
                    </Wrapper>
                    {this.renderTabs()}
                  </Wrapper>

                  <Wrapper style={{}}>
                    <StartStep
                      {...this.props}
                      active_tab={this.state.active_tab}
                      updateTab={this.updateTab}
                    />
                    <CreateNumberStep
                      {...this.props}
                      active_tab={this.state.active_tab}
                      updateTab={this.updateTab}
                    />
                    <SavedRepliesStep
                      {...this.props}
                      active_tab={this.state.active_tab}
                      updateTab={this.updateTab}
                    />
                    <MultiSendStep
                      {...this.props}
                      active_tab={this.state.active_tab}
                      updateTab={this.updateTab}
                    />
                    <FinalStep
                      {...this.props}
                      active_tab={this.state.active_tab}
                      updateTab={this.updateTab}
                    />
                  </Wrapper>
                </Card>
              </Wrapper>
              <News {...this.props} />
            </Row>
          </Wrapper>
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, message }) => {
  const { token, user } = auth;
  const {
    device,
    platform,
    isMobile,
    isIphoneX,
    mobile_toggle_drawer
  } = native;
  const { colors } = settings;
  const { team_phone_number_groups } = message;

  return {
    token,
    user,
    device,
    platform,
    isMobile,
    isIphoneX,
    mobile_toggle_drawer,
    colors,
    team_phone_number_groups
  };
};

export default connect(mapStateToProps, {
  updateDashboard
})(MessageOnboardingSteps);
